import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Link as Link2 } from "react-router-dom";

import Laptop from "../assets/images/bg/laptop.png";

export default function Team({ team }) {
  return (
    <section className="section overflow-hidden" id="team">
      <Container>
        <Row className="justify-content-center">
          <div className="col-12">
            <div className="section-title text-center mb-4 pb-2">
              <h4 className="title mb-3">Our Leadership</h4>
              <p className="para-desc mx-auto text-muted mb-0">
                Our leadership team brings a wealth of experience and expertise
                in data, business and technology.
              </p>
            </div>
          </div>
        </Row>

        <Row>
          {team.map((item, key) => (
            <Col lg={3} md={6} className="mt-4 pt-2" key={key}>
              <Card className="team-card border-0 text-center shadow border-0 overflow-hidden rounded">
                <img
                  src={item.image}
                  className="team-thumbnail"
                  alt={item.name}
                />
                <CardBody>
                  <h5 className="mb-1">{item.name}</h5>
                  <small className="text-muted fw-bold">{item.role}</small>
                  <div className="description-section text-muted mt-2 mb-0 small text-justify">
                    {item.description}
                  </div>
                  {item.email && (
                    <div className="email-section">
                      <small className="d-block">
                        <i className="mdi mdi-email me-1"></i>
                        <br />
                        {item.email}
                      </small>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      {/* <div className="container mt-100 mt-60">
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="me-lg-5">
              <div className="row justify-content-center">
                <div className="col-12">
                  <div className="section-title text-center text-md-start mb-4 pb-2">
                    <h4 className="title mb-3">Work Process</h4>
                    <p className="para-desc text-muted mx-auto mb-0">
                      Launch your campaign and benefit from our expertise on
                      designing and managing conversion centered bootstrap
                      v5 html page.
                    </p>
                  </div>
                </div>
              </div>

              <Row>
                <div className="col-md-12 mt-4 pt-2">
                  <div className="features feature-primary rounded border-0 d-flex">
                    <div className="feature-icon sm-icon text-center">
                      <i className="rounded-pill">1</i>
                    </div>

                    <div className="content flex-1 ms-3">
                      <Link2 to="#" className="title h5 text-dark">
                        Concept
                      </Link2>
                      <p className="text-muted mt-2 mb-0">
                        This prevents repetitive impairing the overall
                        facilitates the comparison.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-12 mt-4 pt-2">
                  <div className="features feature-primary rounded border-0 d-flex">
                    <div className="feature-icon sm-icon text-center">
                      <i className="rounded-pill">2</i>
                    </div>

                    <div className="content flex-1 ms-3">
                      <Link2 to="#" className="title h5 text-dark">
                        Development
                      </Link2>
                      <p className="text-muted mt-2 mb-0">
                        This prevents repetitive impairing the overall
                        facilitates the comparison.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-12 mt-4 pt-2">
                  <div className="features feature-primary rounded border-0 d-flex">
                    <div className="feature-icon sm-icon text-center">
                      <i className="rounded-pill">3</i>
                    </div>

                    <div className="content flex-1 ms-3">
                      <Link2 to="#" className="title h5 text-dark">
                        Live Demo
                      </Link2>
                      <p className="text-muted mt-2 mb-0">
                        This prevents repetitive impairing the overall
                        facilitates the comparison.
                      </p>
                    </div>
                  </div>
                </div>
              </Row>
            </div>
          </div>

          <div className="col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
            <div className="img-fluid-responsive position-relative">
              <img src={Laptop} className="mx-auto d-block" alt="" />
            </div>
          </div>
        </div>
      </div> */}
    </section>
  );
}
